<template>
<div class="m-common">
    <div class="common">
        <div v-if="bbsLists">
            <div class="control-height">
                  <div class="head-nav">
            <nav class="down-pull">
                <div class="pull pull1">
                    <div class="title">{{pull1Current.value}}</div>
                    <ul>
                        <li @click="changPull1(item)" v-for="(item,index) in pull1" :key="index">{{item.value}}</li>
                    </ul>
                    <i></i>
                </div>
                <div class="pull pull2">  
                    <div class="title">{{pull2Current.value}}</div>
                    <ul>
                        <li @click="changPull2(item)" v-for="(item,index) in pull2" :key="index">{{item.value}}</li>
                    </ul>
                    <i></i>
                </div>
                <div class="pull pull3"> 
                    <div class="title">{{pull3Current.value}}</div>
                    <ul>
                        <li @click="changPull3(item)" v-for="(item,index) in pull3" :key="index">{{item.value}}</li>
                    </ul>
                    <i></i>
                </div>
                <div class="pull pull4"> 
                    <div class="title">{{pull4Current.value}}</div>
                    <ul>
                        <li @click="changPull4(item)" v-for="(item,index) in pull4" :key="index">{{item.value}}</li>
                    </ul>
                    <i></i>
                </div>
            </nav>
                <div class="search-count" v-if="bbsLists.searchCount">相关结果{{bbsLists.searchCount | formatThousand}}个</div>
            </div>
            <bbs-head :bbsInfo=bbsLists.bbsInfo v-if="bbsLists.bbsInfo"></bbs-head>
            <article class="paragraph" v-for="(list,index) in bbsLists.result" :key="index">
                <strong>
                    <a :href="`//bbs.pcauto.com.cn/topic-${list.url}.html`" target="_blank" v-html="list.title" @click="countAd(4267)"></a>
                    <img v-if="list.isPick == 1" src="//www1.pcauto.com.cn/2014/kuaisou/images/jing.png">
                    <img v-if="list.isPhotosNum == 1" src="//www1.pcauto.com.cn/2012/ks/images/pic.png">
                </strong>
                <a href="//bbs.pcauto.com.cn/topic-21925791.html" class="docLink" target="_blank">
                    <div class="doc" v-html="list.summary"></div>
                </a>
                <div class="paragraphInfo">
                    <span v-if="list.forum"><i>论坛：</i><a :href="list.forum ? `//bbs.pcauto.com.cn/forum-${list.forum}.html` : 'javascript:;'" :target="list.forum ? '_blank' : '' " :title="list.category" @click="countAd(4268)">{{list.category}}</a></span>
                    <span><i>作者：</i><a :href="`//my.pcauto.com.cn/${list.authorId}/forum`" target="_blank" @click="countAd(4269)">{{list.login || list.author}}</a></span>
                    <span><i>时间：</i>{{list.date}}</span>
                </div>
            </article>
            </div>
            <paging :totalPages=totalPages @reqData=reqBbs></paging>
            <search-box :id="2"></search-box>
        </div>
        <error-acrticle v-else :id="4270"></error-acrticle>
    </div>
    <common-side v-if="bbsLists" :serailRightData=serailRightData :RightCarsConcern=RightCarsConcern :brandOrVendorRightData=brandOrVendorRightData :RightBrandOrVendorMyConcern=RightBrandOrVendorMyConcern></common-side>
</div>
</template>
<script>
import ErrorAcrticle from '../../global/ErrorAcrticle.vue'
import CommonSide from '../../sides/Common'
import BbsHead from '../../global/BbsHead.vue'
    export default {
        name: 'Common',
        components:{ CommonSide, BbsHead, ErrorAcrticle },
        data() {
            return {
                pull1Current: {value: '最相关', param:'', id: 0}, //第一个下拉框的当前列
                pull2Current: {value: '全部类型', param:'', id: 0}, //第二个下拉框的当前列
                pull3Current: {value: '全部论坛', param:'', id: 0}, //第三个下拉框的当前列
                pull4Current: {value: '全部时间', param:'', id: 0}, //第四个下拉框的当前列
                pull1: [
                    {value: '最相关', param:'', id: 1},
                    {value: '最新发布', param:'time', id: 2},
                    {value: '最多回复', param:'replycount', id: 3},
                
                ],
                pull2: [
                    {value: '全部类型', param:'', id: 1},
                    {value: '精华帖', param:'isPick', id: 2},
                    {value: '图片贴', param:'isPhotosNum', id: 3},
                    
                ],
                pull3: [],
                pull4: [    
                    {value: '全部时间', param:'', id: 1},
                    {value: '一周内', param:'week', id: 2},
                    {value: '一个月内', param:'month', id: 3},
                    {value: '一年内', param:'year', id: 4},
                ],
                bbsLists: {}, //论坛数据
                totalPages: 0, //总页数
                /* 
                * 下拉框参数
                */
               pageNo: 1, //页数
               sort: '', //排序  
               clusterQuery: '', //论坛类型
               bbsType: '', //精华帖,图片贴
               searchTime: '', //时间排序
               path: '', //来自某个论坛搜索
               enableHomonym: true, //是否使用同音词搜索

                serailRightData: {}, //车系专区模块数据
                brandOrVendorRightData: {}, //品牌专区模块数据
                
                RightCarsConcern: [], //右侧车系可能关注
                RightBrandOrVendorMyConcern: [], //右侧品牌或厂商可能关注
            }
        },
        methods: {
            changPull1(item) {
                this.countAd(4260)
                if(item.value === this.pull1Current.value) return
                this.pull1Current = item
                this.sort = item.param
                this.reqBbs(this.pageNo)
            },
            changPull2(item) {
                this.countAd(4261)
                if(item.value === this.pull2Current.value) return
                this.pull2Current = item
                this.bbsType = item.param
                this.reqBbs(this.pageNo)
            },
            changPull3(item) {
                this.countAd(4262)
                if(item.value === this.pull3Current.value) return
                this.pull3Current = item
                this.clusterQuery = item.param
                this.reqBbs(this.pageNo)
            },
            changPull4(item) {
                this.countAd(4263)
                if(item.value === this.pull4Current.value) return
                this.pull4Current = item
                this.searchTime = item.param
                this.reqBbs(this.pageNo)
            },
            //重置参数
            restParmas() {
                this.pageNo='',
                this.sort='',
                this.clusterQuery='',
                this.searchTime='',
                this.bbsType='',
                this.enableHomonym='',
                this.pat=''
            },
            async reqBbs(pageNo = 1) {
                try {
                    const res = await this.fetBbs({
                        q:this.$global.q,
                        pageNo,
                        sort:this.sort,
                        clusterQuery:this.clusterQuery,
                        searchTime:this.searchTime,
                        bbsType:this.bbsType,
                        enableHomonym:this.enableHomonym,
                        path:this.path
                    })
                    if(res) {
                        document.body.scrollTop = document.documentElement.scrollTop = 0
                    }                    
                    this.bbsLists = res
                    this.totalPages = res.totalPage
                    this.$global.qType = res.type
                    this.pageNo = pageNo
                    if(res.clusterResult) {
                        const clusterResult = Object.keys(res.clusterResult).map(v => {
                            return {value:v,param:v,id:res.clusterResult[v]}
                        })
                        this.pull3 = [{value: '全部论坛', param:'', id: 0}]
                        this.pull3.push(...clusterResult)
                    }
                    if(!res) {
                        this.restParmas()
                    }
                    if(res.type === 1) {
                        this.reqRightBrand(res.id)
                        this.reqBrandConcern(res.id)
                    }else if(res.type === 2) {
                        this.reqVdendorConcern(res.id)
                        this.reqRightVendor(res.id)
                    }else if(res.type === 3) {
                        this.reqRightCars(res.id,this.$global.rid)
                        this.reqRightCarsConcern(res.id)
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            //请求右侧豆腐块车系专区模块数据
            async reqRightCars(sid,city) {
                try {
                    const res = await this.fetRightCars({
                        sid,
                        city
                    })
                    this.serailRightData = res
                } catch (error) {
                    console.error(error)
                }
            },
            //请求右侧豆腐块品牌专区模块数据 
            async reqRightBrand(bid) {
                try {
                    const res = await this.fetRightBrand({
                        bid
                    })
                    this.brandOrVendorRightData = res
                } catch (error) {
                    console.error(error)
                }
            },
            //请求右侧豆腐块厂商专区模块数据 
            async reqRightVendor(fid) {
                try {
                    const res = await this.fetRightVendor({
                        fid
                    })
                    this.brandOrVendorRightData = res
                } catch (error) {
                    console.error(error)
                }
            },            
            //请求右侧豆腐块车系可能关注模块数据 
            async reqRightCarsConcern(sid) {
                try {
                    const res = await this.fetRightCarsConcern({
                        sid
                    })
                    this.RightCarsConcern = res
                } catch (error) {
                    console.error(error)
                }
            },
            //请求右侧豆腐块品牌可能关注模块数据 
            async reqBrandConcern(bid) {
                try {
                    const res = await this.fetBrandConcern({
                        bid
                    })
                    this.RightBrandOrVendorMyConcern = res
                } catch (error) {
                    console.error(error)
                }
            },      
            //请求右侧豆腐块厂商可能关注模块数据 
            async reqVdendorConcern(fid) {
                try {
                    const res = await this.fetVdendorConcern({
                        fid
                    })
                    this.RightBrandOrVendorMyConcern = res
                } catch (error) {
                    console.error(error)
                }
            },                        
        },
        filters: {
            //千位加逗号
             formatThousand (num) {  
                var reg=/\d{1,3}(?=(\d{3})+$)/g;   
                return (num + '').replace(reg, '$&,');  
            }
        },
        mounted() {
            // if(this.$global.tab.title == 'auto_bbs') {
            this.countColumnAd(3451)
            this.reqBbs(this.pageNo)
            // this.$EventBus.$on(`${this.$global.tab.title}`,() => {this.reqBbs(this.pageNo)})
            // }
        }
    }
</script>

<style lang="scss" scoped>
.m-common {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.common {
    width: 620px;
    .head-nav {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eeeeee;
        .search-count {
            line-height: 47px;
            color: #999999;
        }
        .down-pull {
            display: flex;
            font-size: 12px;
            color: #225599;
            height: 46px;
            align-items: center;
            .pull {
                height: 28px;
                line-height: 28px;
                position: relative;
                margin-left: 10px;
                box-sizing: border-box;
                    i {
                        display: block;
                        width: 7px;
                        height: 4px;
                        position: absolute;
                        right: 8px;
                        top: 11px;
                        overflow: hidden;
                        background-image: url($imageURL);
                        background-position: -8px -29px;
                    }
                .title {
                    width: 80px ;
                    border: 1px solid transparent;
                    padding-left: 6px;
                    cursor: pointer;
                    background-color: #fcfcfc;
                }
                ul {
                    position: absolute;
                    top: 28px;
                    left: 0;
                    display: none; 
                    background-color: #fcfcfc; 
                    width: 80px;
                    cursor: pointer;
                    color: #777777;
                    z-index: 88;
                    width: 100%;
                }
                &.pull1 {
                    &:hover {
                        ul{
                            display: block;
                            border: 1px solid #e5e5e5;
                        }
                        i {
                            transform: rotate(180deg);
                        }
                    }
                }
                &.pull2 {
                    &:hover {
                        ul{
                            display: block;
                            border: 1px solid #e5e5e5;
                        }
                        i {
                            transform: rotate(180deg);
                        }
                    }
                }
                &.pull3 {
                    .title {
                        min-width: 120px;
                        white-space: nowrap;
                    }
                    &:hover {
                        ul{
                            display: block;
                            border: 1px solid #e5e5e5;
                        }
                        i {
                            transform: rotate(180deg);
                        }
                    }
                }
                &.pull4 {
                    &:hover {
                        ul{
                            display: block;
                            border: 1px solid #e5e5e5;
                        }
                        i {
                            transform: rotate(180deg);
                        }
                    }
                }
                li {
                    width: 100%;
                    padding-left: 6px;
                    box-sizing: border-box;
                    &:hover {
                        background-color: #f3f3f3;
                        color: #225599;
                    }
                }
                &:first-of-type {
                    margin-left: 0;
                }
            }
        }
    }
    .paragraph {
        margin-top: 25px;
        strong {
        font-weight: normal;
        font-size: 16px;
        line-height: 32px;
            a {
                text-decoration: underline;
                color: #225599;
                ::v-deep font{
                    color: rgb(225, 9, 0);
                }
                ::v-deep em {
                    color: rgb(225, 9, 0);
                    font-style: normal;
                }
            }
            img {
                border: 0;
                vertical-align: middle;
                margin-left: 8px;
            }
        }
    .docLink {
        text-decoration: none;
        display: block;
        .doc {
            color: #333333;
            line-height: 22px;
            overflow: hidden;
            position: relative;
            ::v-deep em {
                color: rgb(225, 9, 0);
                font-style: normal;
            }
            font {
                color: rgb(225, 9, 0);
            }
        }
    }
    .paragraphInfo {
        span {
            min-width: 120px;
            display: inline-block;
            color: #333333;
            height: 20px;
            overflow: hidden;
            word-break: break-all;
            word-wrap: break-word;
            margin-right: 10px;
            i {
                color: #777777;
                font-style: normal;
            }
            a {
                color: #000;
                text-decoration: none;
                outline: none;
            }
        }
    }
    }
}
</style>